<template>
    <v-list-tile class="sidebar-profile">
        <v-list-tile-avatar>
            <img v-lazy="{src:getAvatar(), error: getGravatar(user.avatar)}" />
        </v-list-tile-avatar>
        <v-list-tile-content class="ml-3">
            <v-list-tile-title><span>{{user.name}}</span></v-list-tile-title>
        </v-list-tile-content>
        <v-menu bottom
            offset-y
            left
            content-class="userblock-dropdown" 
            nudge-top="-10"
            nudge-right="0"
            transition="slide-y-transition"
            v-if="user && user.email">
            <v-btn icon slot="activator" class="ma-0">
                <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
                <v-list-tile :to="menu.url" v-for="(menu,i) in menuItems" :key="i" v-if="hasRole(menu.authenticate)">
                    <v-icon class="mr-3 font-lg gray--text">{{menu.icon}}</v-icon>
                    <v-list-tile-title>{{$t(menu.text)}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logoutUser">
                    <v-icon class="mr-3 font-lg gray--text">ti-power-off</v-icon>
                    <v-list-tile-title>{{$t('message.logOut')}}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-list-tile>
</template>

<script>
    import md5 from 'md5'
    import { mapGetters, mapState } from 'vuex'
    export default {
        data: () => ({
            userAvatar: '/'
        }),
        computed: {
            ...mapState({
                menuItems: state => state.menuItems,
                cartItems: state => state.cart.items,
            }),
            ...mapGetters({
                user: 'auth/user',
                hasRole: 'auth/hasRole',
                loadItems: 'cart/loadItems', // This loads the cart items from localStorage
                totalCount: 'cart/totalCount',
                getTotalAmount: 'cart/getTotalAmount'
            })
        },
        methods: {
            logoutUser() {
              this.$store.dispatch('auth/logout')
              this.$router.push('/account/login')
            },
            getAvatar() {
                return this.userAvatar = '/static/avatars/' + this.user.avatar;
            },
            getGravatar(img) {
              let email = this.user && this.user.email || '';
              let githubUrl = 'https://www.gravatar.com/avatar/' + md5(email.toLowerCase().trim());
              return githubUrl;
            }
      }
};
</script>
